import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon-rectangle-w.svg'
import _imports_1 from '@/assets/icon-cross-w.svg'
import _imports_2 from '@/assets/icon-plus-blue.svg'
import _imports_3 from '@/assets/btn_close.svg'


const _withScopeId = n => (_pushScopeId("data-v-2f295972"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrpr" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "btn_close"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 0,
  class: "step01"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "地図をクリックして表示する範囲を描いてください", -1))
const _hoisted_11 = {
  key: 1,
  class: "step02"
}
const _hoisted_12 = { class: "top_area" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "txt" }, "可視化する道路を選択", -1))
const _hoisted_14 = { class: "list_select" }
const _hoisted_15 = {
  key: 0,
  class: "add_polygon_area"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "jr-inline-block jr-align-text-top jr-mr-1.25",
  src: _imports_2,
  alt: "plus"
}, null, -1))
const _hoisted_17 = {
  key: 1,
  class: "polygon_add_txt"
}
const _hoisted_18 = { class: "close" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UIButton = _resolveComponent("UIButton")!
  const _component_UIListSelect = _resolveComponent("UIListSelect")!
  const _component_UIColorToggler = _resolveComponent("UIColorToggler")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "container",
      style: _normalizeStyle({ width: _ctx.minimum ? '64px' : '240px' })
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          (!_ctx.minimum)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_4, "範囲選択表示"))
            : _createCommentVNode("", true),
          (!_ctx.minimum)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearAll && _ctx.clearAll(...args)))
                }, _hoisted_7)
              ]))
            : _createCommentVNode("", true)
        ]),
        (!_ctx.minimum)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
              (_ctx.step === 1)
                ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                    _hoisted_10,
                    _createVNode(_component_UIButton, {
                      class: _normalizeClass([{enable : _ctx.isEnablePolygonBtn, 'jr-pointer-events-none': !_ctx.isEnablePolygonBtn }, "btn_display"]),
                      type: _ctx.ButtonType.primary,
                      style: {opacity: 1},
                      label: "選択した範囲で表示",
                      onClick: _ctx.onShowSelected
                    }, null, 8, ["class", "type", "onClick"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.step === 2)
                ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("p", {
                        class: "btn_clear",
                        style: _normalizeStyle({opacity: _ctx.isSelectedRoad ? 1 : 0.3 })
                      }, [
                        _createElementVNode("a", {
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleClearHeatmap && _ctx.handleClearHeatmap(...args))),
                          href: "#"
                        }, "クリア")
                      ], 4)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_UIListSelect, {
                        options: _ctx.roadSeachOpt,
                        "onUpdate:modelValue": _ctx.handleRoadOption,
                        label: "道路名から絞り込む",
                        ref: "multiSelector"
                      }, null, 8, ["options", "onUpdate:modelValue"])
                    ]),
                    (!_ctx.minimum && _ctx.isSelectedRoad)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          (!_ctx.minimum && _ctx.isSelectedRoad)
                            ? (_openBlock(), _createBlock(_component_UIButton, {
                                key: 0,
                                type: _ctx.ButtonType.classic,
                                label: "絞り込み範囲を追加",
                                onClick: _ctx.handleNewPolygon,
                                disabled: _ctx.$store.getters['hasNewPolygon'],
                                class: _normalizeClass([{enable: !_ctx.$store.getters['hasNewPolygon']}, "btn_add_polygon jr-py-2 jr-mt-4 jr-w-12/25 jr-rounded-md jr-text-center jr-text-sm"])
                              }, {
                                icon: _withCtx(() => [
                                  _hoisted_16
                                ]),
                                _: 1
                              }, 8, ["type", "onClick", "disabled", "class"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("p", {
                            class: "btn_clear",
                            style: _normalizeStyle({opacity: _ctx.$store.getters['hasNewPolygon'] ? 1.0 : 0.3 })
                          }, [
                            _createElementVNode("a", {
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleClearNewPolygon && _ctx.handleClearNewPolygon(...args))),
                              href: "#"
                            }, "クリア")
                          ], 4)
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.minimum && _ctx.isSelectedRoad)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_17, "地図をクリックして絞り込む範囲を描いてください"))
                      : _createCommentVNode("", true),
                    (!_ctx.minimum)
                      ? (_openBlock(), _createBlock(_component_UIButton, {
                          key: 2,
                          type: _ctx.ButtonType.primary,
                          style: _normalizeStyle({opacity: _ctx.isSelectedRoad ? 1 : 0.25}),
                          class: _normalizeClass([{ 'jr-pointer-events-none': !_ctx.isSelectedRoad }, "btn_submit jr-py-2 jr-mt-4 jr-w-12/25 jr-rounded-md jr-text-center jr-text-sm"]),
                          label: "選択内容で可視化",
                          onClick: _ctx.handleReport
                        }, null, 8, ["type", "style", "class", "onClick"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", {
          class: "btn_close",
          style: _normalizeStyle({ transform: (_ctx.minimum ? 'rotate(180deg)' : 'rotate(0deg)') })
        }, [
          _createElementVNode("a", {
            href: "#",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClickClose && _ctx.onClickClose(...args)))
          }, _hoisted_20)
        ], 4)
      ])
    ], 4),
    _createElementVNode("div", {
      class: "color_chart",
      style: _normalizeStyle({ left: _ctx.minimum ? '64px' : '240px' })
    }, [
      (_ctx.roadSeachOpt.length > 0)
        ? (_openBlock(), _createBlock(_component_UIColorToggler, {
            key: 0,
            colors: _ctx.colors,
            modelValue: _ctx.$store.state.isShowHeatmap,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.$store.state.isShowHeatmap) = $event))
          }, null, 8, ["colors", "modelValue"]))
        : _createCommentVNode("", true)
    ], 4)
  ], 64))
}